// src/components/SaverCreditCallout.js
import React from "react";
import "./SaverCreditCallout.css";

const SaverCreditCallout = () => {
  return (
     <section className="sc-callout">
        <div className="sc-callout-content">
          <span className="sc-callout-pill">Most people miss this</span>
          <h2 className="sc-callout-title">
            Almost half of eligible workers never use this credit.
          </h2>
          <p className="sc-callout-text">
           The Saver’s Credit is part of the regular tax form, but many people never realize it exists or where it appears. This module will walk you through it step by step.
          </p>
        </div>

        <div className="sc-callout-stat" style ={{textAlign: "center"}}>
          <p className="sc-stat-label"><strong>Missed each year</strong></p>
          <p className="sc-stat-value">~50%</p>
          <p className="sc-stat-note">
            IRS and survey data (approximate, educational use).
          </p>
        </div>
      </section>
  );
};

export default SaverCreditCallout;
